import { forwarded } from '@snsw-gel/utils'
import React, { ReactNode, Ref } from 'react'
import { RowStyled } from './Row.styled'

export interface RowProps {
    className?: string
    children?: ReactNode
    alignItems?: 'start' | 'center' | 'end' | 'stretch'
    justifyContent?:
        | 'start'
        | 'center'
        | 'end'
        | 'space-between'
        | 'space-around'
        | 'space-evenly'
}

export const Row = forwarded((props: RowProps, ref: Ref<HTMLDivElement>) => {
    return (
        <RowStyled {...props} ref={ref}>
            {props.children}
        </RowStyled>
    )
})
